export default {
  namespaced: true,
  state() {
    return {
      enableRepack: false,
      enableAirFreight: false,
      enableInternationalImport: false,
      enablePackingList: false,
      enableSalesRegular: false,
      enableBP: false,
      enableOCP: false,
      enableCreditNotePayment: false,
      enableGroupShipping: false,
      defaultPort: '',
      defaultReport: false,
      defaultRepack: false
    }
  },
  getters: {
    isEnableRepack(state) {
      return state.enableRepack
    },
    isEnableAirFreight(state) {
      return state.enableAirFreight
    },
    isEnableInternationalImport(state) {
      return state.enableInternationalImport
    },
    isEnablePackingList(state) {
      return state.enablePackingList
    },
    isEnableSalesRegular(state) {
      return state.enableSalesRegular
    },
    isEnableBP(state) {
      return state.enableBP
    },
    isEnableOCP(state) {
      return state.enableOCP
    },
    isEnableCreditNotePayment(state) {
      return state.enableCreditNotePayment
    },
    isEnableGroupShipping(state) {
      return state.enableGroupShipping
    },
    defaultReport(state) {
      return state.defaultReport
    },
    defaultRepack(state) {
      return state.defaultRepack
    },
    defaultPort(state) {
      return state.defaultPort
    }
  },
  mutations: {
    setEnableRepack(state) {
      state.enableRepack = process.env.ENABLE_REPACK
    },
    setEnableAirFreight(state) {
      state.enableAirFreight = process.env.ENABLE_AIR_FREIGHT
    },
    setEnableInternationalImport(state) {
      state.enableInternationalImport = process.env.ENABLE_INTERNATIONAL_IMPORT
    },
    setEnablePackingList(state) {
      state.enablePackingList = process.env.ENABLE_PACKING_LIST
    },
    setEnableSalesRegular(state) {
      state.enableSalesRegular = process.env.ENABLE_SALES_REGULAR
    },
    setEnableBP(state) {
      state.enableBP = process.env.ENABLE_BP
    },
    setEnableOCP(state) {
      state.enableOCP = process.env.ENABLE_OCP
    },
    setEnableCreditNotePayment(state) {
      state.enableCreditNotePayment = process.env.ENABLE_CREDIT_NOTE_PAYMENT
    },
    setEnableGroupShipping(state) {
      state.enableGroupShipping = process.env.ENABLE_GROUP_SHIPPING
    },
    setDefaultPort(state) {
      state.defaultPort = process.env.DEFAULT_PORT
    },
    setDefaultReport(state) {
      state.defaultReport = process.env.DEFAULT_REPORT
    },
    setDefaultRepack(state) {
      state.defaultRepack = process.env.DEFAULT_REPACK
    }
  },
  actions: {
    loadConfig({commit}) {
      commit('setEnableRepack')
      commit('setEnableAirFreight')
      commit('setEnableInternationalImport')
      commit('setEnablePackingList')
      commit('setEnableSalesRegular')
      commit('setEnableBP')
      commit('setEnableOCP')
      commit('setEnableCreditNotePayment')
      commit('setEnableGroupShipping')
      commit('setDefaultPort')
      commit('setDefaultReport')
      commit('setDefaultRepack')
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/config.js